import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { queryClient } from "../App";
import { IUseDeleteCategoryComponentMutationResponse } from "../utils/types";

const useDeleteCategoryComponent =
  (): IUseDeleteCategoryComponentMutationResponse =>
    useMutation({
      mutationFn: async (data: any) => {
        const response = await AXIOS_RESERVATION.delete(
          `${data.url}/${data._id}`,
        );
        return response.data;
      },
      onSuccess: () => {
        queryClient.refetchQueries({ queryKey: ["services-components"] });
      },
    });

export default useDeleteCategoryComponent;
